import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgUrl } from "@/lib/api";
import { btn } from "@/lib/ui";
import { PriceBlock, StockBadge } from "@/components/shop/ProductBits";

export const SpineFitBand = () => {
  const [product, setProduct] = useState(null);
  useEffect(() => {
    api.get("/products").then((r) => setProduct(r.data[0] || null)).catch(() => setProduct(null));
  }, []);
  if (!product) return null;
  const img = product.images?.[0];
  return (
    <section className="section" aria-labelledby="spinefit-heading" data-testid="home-spinefit-band">
      <div className="container-x">
        <div className="relative grid items-center gap-10 overflow-hidden rounded-[2rem] bg-gradient-to-br from-brand-greenTint via-white to-brand-skyTint p-6 ring-1 ring-brand-green/15 sm:p-10 lg:grid-cols-2 lg:gap-16 lg:p-14">
          <span className="blob -right-16 -top-16 h-64 w-64 bg-brand-lime/30" aria-hidden="true" />
          <span className="blob -bottom-20 left-10 h-56 w-56 bg-brand-sun/20" aria-hidden="true" />
          <Link to={`/shop/${product.slug}`} className="relative block overflow-hidden rounded-3xl bg-white shadow-[0_30px_60px_-34px_rgba(66,118,27,0.5)] ring-1 ring-brand-green/20 transition-transform duration-500 hover:-rotate-1 hover:scale-[1.01]" aria-label={`View ${product.name}`}>
            <img src={imgUrl(img?.thumb || img?.url)} alt={img?.alt || product.name} loading="lazy" width="640" height="640" className="aspect-square w-full object-cover" />
          </Link>
          <div className="relative">
            <p className="eyebrow !text-brand-greenDeep">From the Young Spine shop</p>
            <h2 id="spinefit-heading" className="font-heading text-3xl font-extrabold tracking-tight text-brand-ink sm:text-4xl">{product.name}</h2>
            <p className="mt-2 text-lg font-medium text-brand-greenDeep">{product.subtitle}</p>
            {product.origin_note && <p className="mt-4 text-base text-slate-700">{product.origin_note}</p>}
            <p className="mt-2 text-sm text-slate-600">{product.product_type} · {product.pack_size}. Designed to complement a healthy, active lifestyle — not to replace medical evaluation or treatment.</p>
            <div className="mt-6"><PriceBlock product={product} size="sm" /></div>
            <div className="mt-3"><StockBadge product={product} /></div>
            <Link to={`/shop/${product.slug}`} className={`${btn("green", "lg")} mt-8`} data-testid="home-spinefit-shop-btn">Shop Now</Link>
          </div>
        </div>
      </div>
    </section>
  );
};
